import { render, staticRenderFns } from "./ShipmentNotifications.vue?vue&type=template&id=8c88ce26"
import script from "./ShipmentNotifications.vue?vue&type=script&lang=js"
export * from "./ShipmentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports